package presentation.screens.business.inventory.product.create.component

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import common.asset.ImageAsset
import component.input.CustomTextField
import feature.product.viewModel.ProductViewModel

@Composable
fun CreateProductBasicInfo(viewModel: ProductViewModel) {
    val product = viewModel.newProduct.collectAsState()
    val nameErrorState = remember { mutableStateOf(false) }
    val salePriceErrorState = remember { mutableStateOf(false) }
    Column(
        modifier = Modifier.fillMaxWidth().padding(bottom = 10.dp)
    ) {
        CustomTextField(
            value = product.value?.Name ?: "",
            placeholder = "Name of the Product",
            trailingIcon = ImageAsset.person,
            label = "Name",
            errorState = nameErrorState.value,
            keyboardType = KeyboardType.Email,
            visualTransformation = VisualTransformation.None
        ) { newValue ->
            viewModel.setNewProductName(newValue.text)
        }
        CustomTextField(
            value = product.value?.Description ?: "",
            placeholder = "Details about product",
            trailingIcon = ImageAsset.person,
            label = "Description",
            errorState = nameErrorState.value,
            keyboardType = KeyboardType.Email,
            visualTransformation = VisualTransformation.None
        ) { newValue ->
            viewModel.setNewProductDescription(newValue.text)
        }
        CustomTextField(
            value = product.value?.ProductPrice?.FinalPrice?.toString() ?: "",
            placeholder = "Sale Price",
            trailingIcon = ImageAsset.person,
            label = "Sale Price",
            errorState = salePriceErrorState.value,
            keyboardType = KeyboardType.Number,
            visualTransformation = VisualTransformation.None
        ) { newValue ->
            viewModel.setNewProductFinalPricePrice(newValue.text)
        }
    }
}